module.exports = __webpack_public_path__ + "assets/certificate_pdf/DUKE_AFTEREFFECT.582248d7.pdf";